import en from './locales/en.json'
import it from './locales/it.json'

export default {
  en,
  it
}
